
	/* 自动按 location.hostname 切 dev/prod/myjk；勿改顺序（axiosconf.js 模块加载时读取） */
	const host = typeof window !== 'undefined' ? window.location.hostname : ''
	const isMyjk = host === 'app.myjk-cn.com'   /* 脉钥生产（单机 114.55.89.183） */
	const isProd = host === 'store.jythx.com'   /* 健康商城灰度 */
	const apiBase = isMyjk
		? 'https://app.myjk-cn.com/SMY_TONGUE/'
		: isProd
			? 'https://store.jythx.com/SMY_TONGUE/'
			: 'http://localhost:8280/SMY_TONGUE/'
	/* AI 仅供内网调用，浏览器实际无法直达；当前 desktop 也没有任何 .vue 调用 multipartPostImageRecognition，仅为保留语义指向内网 */
	const aiBase = isMyjk ? 'http://127.0.0.1:5000/v1/' : isProd ? 'http://192.168.135.24:5000/v1/' : 'http://183.207.183.118:5000/v1/'

	const imgPath = apiBase             //图像路径
	const axiosDefaultsURL = apiBase    //服务端地址
	const videoPath = apiBase           //视频相关的接口
	const imageRecognitionURL = aiBase  //图像识别
	export default {
		imgPath,
		axiosDefaultsURL,
		videoPath,
		imageRecognitionURL
	}
